// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English
import enCommon from '@/utils/languagedetector/locales/en/common.json';
import enAuth from '@/utils/languagedetector/locales/en/auth.json';
import enLogin from '@/utils/languagedetector/locales/en/login.json';
import enForgotPassword from '@/utils/languagedetector/locales/en/forgotPassword.json';
import enOtpVerification from '@/utils/languagedetector/locales/en/otpVerification.json';
import enPasswordScreen from '@/utils/languagedetector/locales/en/passwordScreen.json';
import enPortalSelection from '@/utils/languagedetector/locales/en/portalSelection.json';
import enRegistration from '@/utils/languagedetector/locales/en/registration.json';
import enStudentRegistration from '@/utils/languagedetector/locales/en/studentRegistration.json';
import enSrAddressDetails from '@/utils/languagedetector/locales/en/srAddressDetails.json';
import enSrAdmissionDetails from '@/utils/languagedetector/locales/en/srAdminssionDetails.json';
import enSrAcademicDetails from '@/utils/languagedetector/locales/en/srAcademicDetails.json';
import enSrStudentReview from '@/utils/languagedetector/locales/en/srStudentReview.json';
import enDigilockerVerification from '@/utils/languagedetector/locales/en/digilockerVerification.json';
import enApaarVerification from '@/utils/languagedetector/locales/en/apaarVerification.json';
import enStudentPortal from '@/utils/languagedetector/locales/en/studentPortal.json';
import enDigiLockerApaarModal from '@/utils/languagedetector/locales/en/digiLockerApaarModal.js';

// EN - Common Files
import enValidation from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/validation.json';
import enApiErrorResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/apiErrorResponse.json';
import enApiSuccessResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/en/apiSuccessResponse.json';

// Gujarati
import guCommon from '@/utils/languagedetector/locales/gu/common.json';
import guAuth from '@/utils/languagedetector/locales/gu/auth.json';
import guLogin from '@/utils/languagedetector/locales/gu/login.json';
import guForgotPassword from '@/utils/languagedetector/locales/gu/forgotPassword.json';
import guOtpVerification from '@/utils/languagedetector/locales/gu/otpVerification.json';
import guPasswordScreen from '@/utils/languagedetector/locales/gu/passwordScreen.json';
import guPortalSelection from '@/utils/languagedetector/locales/gu/portalSelection.json';
import guRegistration from '@/utils/languagedetector/locales/gu/registration.json';
import guStudentRegistration from '@/utils/languagedetector/locales/gu/studentRegistration.json';
import guSrAddressDetails from '@/utils/languagedetector/locales/gu/srAddressDetails.json';
import guSrAdmissionDetails from '@/utils/languagedetector/locales/gu/srAdminssionDetails.json';
import guSrAcademicDetails from '@/utils/languagedetector/locales/gu/srAcademicDetails.json';
import guSrStudentReview from '@/utils/languagedetector/locales/gu/srStudentReview.json';
import guDigilockerVerification from '@/utils/languagedetector/locales/gu/digilockerVerification.json';
import guApaarVerification from '@/utils/languagedetector/locales/gu/apaarVerification.json';
import guStudentPortal from '@/utils/languagedetector/locales/gu/studentPortal.json';
import guDigiLockerApaarModal from '@/utils/languagedetector/locales/gu/digiLockerApaarModal.js';

// GU - Common Files
import guValidation from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/validation.json';
import guApiErrorResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/apiErrorResponse.json';
import guApiSuccessResponse from '@gyandiksha/shared-ui/utils/languagedetector/locales/gu/apiSuccessResponse.json';

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    // Use '.' as the namespace separator so t('login.key') → namespace: login, key: key
    // Use false for keySeparator since all JSON files have flat (non-nested) keys
    nsSeparator: '.',
    keySeparator: false,

    ns: [
      'common',
      'auth',
      'login',
      'forgot_password_screen',
      'otp_verification_screen',
      'password_screen',
      'portalSelection',
      'registration',
      'validation',
      "apiErrorResponse",
      "apiSuccessResponse",
      "studentRegistration",
      "srAddressDetails",
      "srAcademicDetails",
      "srAdmissionDetails",
      "srStudentReview",
      "digilocker_verification_screen",
      "apaar_verification_screen",
      "student_portal",
      "digilocker_apaar_modal"
    ],
    defaultNS: 'common',

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        common: enCommon,
        auth: enAuth,
        login: enLogin,
        // Map component namespace names → actual JSON file contents
        forgot_password_screen: enForgotPassword,
        otp_verification_screen: enOtpVerification,
        password_screen: enPasswordScreen,
        portal_selection: enPortalSelection,
        registration: enRegistration,
        validation: enValidation,
        apiErrorResponse: enApiErrorResponse,
        apiSuccessResponse: enApiSuccessResponse,
        studentRegistration: enStudentRegistration,
        srAddressDetails: enSrAddressDetails,
        srAcademicDetails: enSrAcademicDetails,
        srAdmissionDetails: enSrAdmissionDetails,
        srStudentReview: enSrStudentReview,
        digilocker_verification_screen: enDigilockerVerification,
        apaar_verification_screen: enApaarVerification,
        student_portal: enStudentPortal,
        digilocker_apaar_modal: enDigiLockerApaarModal
      },
      gu: {
        common: guCommon,
        auth: guAuth,
        login: guLogin,
        forgot_password_screen: guForgotPassword,
        otp_verification_screen: guOtpVerification,
        password_screen: guPasswordScreen,
        portal_selection: guPortalSelection,
        registration: guRegistration,
        validation: guValidation,
        apiErrorResponse: guApiErrorResponse,
        apiSuccessResponse: guApiSuccessResponse,
        studentRegistration: guStudentRegistration,
        srAddressDetails: guSrAddressDetails,
        srAcademicDetails: guSrAcademicDetails,
        srAdmissionDetails: guSrAdmissionDetails,
        srStudentReview: guSrStudentReview,
        digilocker_verification_screen: guDigilockerVerification,
        apaar_verification_screen: guApaarVerification,
        student_portal: guStudentPortal,
        digilocker_apaar_modal: guDigiLockerApaarModal
      },
    },
  });

export default i18n;